import ValueLoader from './ValueLoader';

export default ValueLoader;
